import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import moment from 'moment';

@Component({
  selector: 'app-salary-csv-dialog',
  templateUrl: './salary-csv-dialog.component.html',
  styleUrls: ['./salary-csv-dialog.component.less'],
})

export class SalaryCsvDialogComponent implements OnInit {
  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // 清掃員名検索
  filterName = this.data['filterName'];

  // 清掃員かな検索
  filterNameKana = this.data['filterNameKana'];

  // 清掃員コード
  filterStaffCd = this.data['filterStaffCd'];

  // エリア候補
  areas = this.data['areas'];

  // 選択したエリアID
  areaIds = this.data['areaIds'];

  // CSVインポート用件数
  count1 = 0;

  // 手入力用件数
  count2 = 0;

  // 手入力全件数
  count3 = 0;

  // 一覧用のデータ
  target = {
    staffDailyCleaning: { val: true, name: '清掃員番号' },
    staff: { val: true, name: '清掃員名' },
    staffKana: { val: true, name: '清掃員カナ' },
    nameSite: { val: true, name: '物件名' },
    hourlyWage: { val: true, name: '時給' },
    workDays: { val: true, name: '勤務日数' },
    phDays: { val: true, name: '有休日数' },
    workHours: { val: true, name: '勤務時間' },
    totalPhHours: { val: true, name: '有休時間' },
    hours: { val: true, name: '合計時間' },

    // diffSalary: { val: true, name: '基本給調整' },
    workBasic: { val: true, name: '勤務金額' },
    totalPhBasic: { val: true, name: '有休金額' },
    totalBasic: { val: true, name: '基本給合計' },

    // diffFare: { val: true, name: '交通費調整' },
    totalFare: { val: true, name: '交通費' },
    memoFare: { val: true, name: '交通費備考' },
    area: { val: true, name: 'エリア' },
    areaDetail: { val: true, name: '詳細エリア' },

    isDiff: { val: true, name: '相違あり' },
    isCheck: { val: true, name: '金額OK' },
    adjustStatus: { val: true, name: '承認状況' },
    applicantNote: { val: true, name: '金額変更申請文' },
    note: { val: true, name: 'メモ' },

    totalRow: { val: true, name: '合計行' },
  }

  /** ローディング */
  nowLoading:boolean = true;
  loadingCompleteData:boolean = true;

  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SalaryCsvDialogComponent>) { }

  ngOnInit() {
  }

  ngAfterViewInit() {

    // 給与奉行用の場合
    if (this.data['isSalaryCsv']) {
      this.getCsvCount()
    }

  }

  /**
   * エリア全選択
   */
  selectAllAreas() {
    this.areaIds = this.areas.map(a => a.areaId);
  }

  /**
   * エリア全解除
   */
  clearAllAreas() {
    this.areaIds = [];
  }

  /**
   * エリア検索
   * @param opened 選択肢OPEN
   */
  onSelectOpened(opened: boolean) {
    // 閉じた瞬間だけ検索
    if (!opened) {
      this.getCsvCount()
    }
  }

  /**
   * 件数取得
   */
  getCsvCount() {
    this.nowLoading = true

    let filterStaffCd = this.filterStaffCd
    if (!filterStaffCd || isNaN(this.filterStaffCd)) {
      filterStaffCd = 0
    }

    this.http.get(
      API_BASE_URL + '/api/v1/salary/getCsvCount?'
        + "yearMonth=" + this.data['yearMonth']
        + "&filterName=" + encodeURIComponent(this.filterName)
        + "&filterNameKana=" + encodeURIComponent(this.filterNameKana)
        + "&filterStaffCd=" + filterStaffCd
        + "&areaIds=" + this.areaIds,
      {headers: this.headers}
    )
    .subscribe((res: any) => {
      this.count1 = 0
      this.count2 = 0
      this.count3 = 0
      if (res) {
        this.count1 = res.type1
        this.count2 = res.type2
        this.count3 = res.type3
      }

      this.nowLoading = false
    },
    error => {
      alert("エラー発生");
    });
  }

  /**
   * CSV出力
   */
  downloadCSV(type) {
    let fileName = 'インポート用'
    let msg = 'CSV出力済み'
    if (type == 2) {
      msg = '手入力'
      fileName = '手入力'
    } else if (type == 3) {
      fileName = '手入力再出力'
    }
    if (type != 3 && !window.confirm(msg + 'にチェックが入ります。実行してよろしいでしょうか？\r\nまた、出力が終わるまで画面はそのままにしてください。')) {
      return
    }
    this.loadingCompleteData = false;

    let filterStaffCd = this.filterStaffCd
    if (!filterStaffCd || isNaN(this.filterStaffCd)) {
      filterStaffCd = 0
    }

    const now = moment().format('YYYY-MM-DD HH:mm:ss');

    this.http.get(
      API_BASE_URL + '/api/v1/salary/downloadCSV?'
        + "yearMonth=" + this.data['yearMonth']
        + "&filterName=" + encodeURIComponent(this.filterName)
        + "&filterNameKana=" + encodeURIComponent(this.filterNameKana)
        + "&filterStaffCd=" + filterStaffCd
        + "&areaIds=" + this.areaIds
        + "&type=" + type
        + "&now=" + now
        + "&userId=" + this.data['userId']
        + "&userName=" + this.data['userName'],
      { headers: this.headers, responseType : 'blob' as 'json', observe: 'response'}
    )
    .subscribe(res => {
      if (res['status'] === 204) {
        this.loadingCompleteData = true;
        alert('対象データがありません');
        return;
      }
      const downloadURL = window.URL.createObjectURL(res.body as Blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = '給与奉行_' + fileName + '_' + this.data['yearMonth'] + '.csv';
      link.click();

      this.dialogRef.close(true);
    },
    error => {
      this.loadingCompleteData = true;
      alert("エラーが発生しました。再度お願いします。");
      console.log(error)
    });
  }
  
  /**
   * 一覧出力
   */
  async downloadList() {

    let filterStaffCd = this.data['filterStaffCd']
    if (!filterStaffCd || isNaN(this.filterStaffCd)) {
      filterStaffCd = 0
    }

    this.loadingCompleteData = false;

    this.http.post(
      API_BASE_URL + '/api/v1/salary/downloadList?'
        + "filterName=" + encodeURIComponent(this.data['filterName'])
        + "&filterNameKana=" + encodeURIComponent(this.data['filterNameKana'])
        + "&filterStaffCd=" + filterStaffCd
        + "&filterSite=" + encodeURIComponent(this.data['filterSite'])
        + "&areaIds=" + this.data['areaIds']
        + "&adjustStatus=" + this.data['adjustStatus']
        + "&isDiff=" + this.data['isDiff']
        + "&isCheck=" + this.data['isCheck']
        + "&isCSV=" + this.data['isCSV']
        + "&isAffairs=" + this.data['isAffairs']
        + "&yearMonth=" + this.data['yearMonth'],
        this.target,
      { headers: this.headers, responseType : 'blob' as 'json', observe: 'response'}
    )
    .subscribe(res => {
      this.loadingCompleteData = true;
      if (res['status'] === 204) {
        alert('対象データがありません');
        return;
      }

      const downloadURL = window.URL.createObjectURL(res.body as Blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = '給与一覧_' + this.data['yearMonth'] + '.xlsx';
      link.click();
    },
    error => {
      this.loadingCompleteData = true;
      alert("エラーが発生しました。再度お願いします。");
      console.log(error)
    });
  }

  /**
   * キャンセル
   */
  cancel() {
    this.dialogRef.close();
  }
}


